import React, { useState } from "react";
import { Card, Button, ButtonGroup, Modal, Carousel } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoIosAppstore } from "react-icons/io";
import { Link } from "react-router-dom";
import screenshot1 from "../../Assets/Projects/wordpop/wordpop_store_01.png";
import screenshot2 from "../../Assets/Projects/wordpop/wordpop_store_02.png";
import screenshot3 from "../../Assets/Projects/wordpop/wordpop_store_03.png";
import screenshot4 from "../../Assets/Projects/wordpop/wordpop_store_04.png";
import screenshot5 from "../../Assets/Projects/wordpop/wordpop_store_05.png";
import screenshot6 from "../../Assets/Projects/wordpop/wordpop_store_06.png";

const translations = {
  tr: {
    title: "WordPop Blast",
    description: "Balonları patlatarak kelimeleri tamamlayın! 100 seviyeli, artan zorlukta hızlı bir kelime oyunu. Buz ve kaya engelleri, maskeli harfler, kombo ödülleri, özel balonlar, rozetler ve Game Center liderlik tablosu. Türkçe ve İngilizce destekli.",
    details: "Detaylar",
    privacy: "Gizlilik Politikası",
    terms: "Kullanım Şartları",
    modalTitle: "WordPop Blast - Detaylı Bilgi",
    features: [
      "🎈 100 Seviye: Kolaydan zora artan zorluk eğrisi",
      "🧊 Buz Engelleri: Donmuş harfleri 2 dokunuşla kır (Lv15+)",
      "🪨 Kaya Engelleri: Sert kayaları 3 dokunuşla parçala (Lv25+)",
      "❓ Maskeli Harfler: Gizli harfleri keşfet (Lv16+)",
      "🔥 Özel Balonlar: Ateş, çekiç, yıldız, kalp, zaman bonusu",
      "💥 Kombo Sistemi: 5x buz kırma, 8x kaya hasarı, 10x otomatik doldurma",
      "🏆 10 Rozet Kategorisi: Her biri 5 kademeli başarım sistemi",
      "🌍 2 Dil Desteği: Türkçe ve İngilizce",
      "📊 Game Center: Küresel liderlik tablosu",
      "📱 SwiftUI + SpriteKit ile geliştirildi"
    ]
  },
  en: {
    title: "WordPop Blast",
    description: "Pop balloons to spell words before time runs out! A fast-paced word game with 100 levels of increasing challenge. Features ice & rock obstacles, masked letters, combo rewards, special balloons, badges, and Game Center leaderboards. Available in English and Turkish.",
    details: "Details",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    modalTitle: "WordPop Blast - Detailed Information",
    features: [
      "🎈 100 Levels: Progressive difficulty curve from easy to tough",
      "🧊 Ice Obstacles: Break frozen letters with 2 taps (Lv15+)",
      "🪨 Rock Obstacles: Smash rocks with 3 taps (Lv25+)",
      "❓ Masked Letters: Discover hidden letters (Lv16+)",
      "🔥 Special Balloons: Fire, hammer, star, heart, time bonus",
      "💥 Combo System: 5x ice crack, 8x rock damage, 10x auto-fill",
      "🏆 10 Badge Categories: 5-tier achievement system each",
      "🌍 2 Language Support: English and Turkish",
      "📊 Game Center: Global leaderboards",
      "📱 Built with SwiftUI + SpriteKit"
    ]
  }
};

const screenshots = [
  screenshot1,
  screenshot2,
  screenshot3,
  screenshot4,
  screenshot5,
  screenshot6
];

function WordPopCard({ imgPath }) {
  const [language, setLanguage] = useState("tr");
  const [showModal, setShowModal] = useState(false);
  const content = translations[language];

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={imgPath} alt="card-img" />
        <Card.Body>
          <div style={{ marginBottom: "15px" }}>
            <ButtonGroup size="sm">
              <Button
                variant={language === "tr" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("tr")}
              >
                TR
              </Button>
              <Button
                variant={language === "en" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("en")}
              >
                EN
              </Button>
            </ButtonGroup>
          </div>
          <Card.Title>{content.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {content.description}
          </Card.Text>
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
          >
            <AiOutlineInfoCircle /> &nbsp;
            {content.details}
          </Button>
          <Button
            variant="primary"
            href="https://apps.apple.com/app/wordpop-blast/id6744919498"
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <IoIosAppstore /> &nbsp;
            App Store
          </Button>
          <div style={{ marginTop: "10px" }}>
            <Button
              variant="outline-primary"
              as={Link}
              to="/privacy-policy"
              size="sm"
              style={{ marginRight: "5px" }}
            >
              {content.privacy}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/terms-of-service"
              size="sm"
            >
              {content.terms}
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#1a1a2e", color: "white" }}>
          <Modal.Title>{content.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#16213e", color: "white" }}>
          <Carousel>
            {screenshots.map((screenshot, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={screenshot}
                  alt={`Screenshot ${index + 1}`}
                  style={{ maxHeight: "500px", objectFit: "contain" }}
                />
              </Carousel.Item>
            ))}
          </Carousel>

          <div style={{ marginTop: "20px" }}>
            <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>
              ✨ {content.modalTitle.split(" - ")[1]}
            </h5>
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {content.features.map((feature, index) => (
                <li key={index} style={{ marginBottom: "10px", fontSize: "16px" }}>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#1a1a2e", borderTop: "1px solid #c770f0" }}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default WordPopCard;
